import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CargaZE;
export interface Props {
    value: Entity[];
    readonly?: boolean;
}

const columnasFijas: kea.Grid2Column<Entity>[] = [
    { title: "Folio carga", cell: x => ({ data: x.Folio }) },
    { title: "Fecha carga", cell: x => ({ data: kea.formatDate(x.FechaCarga) }) },
    { title: "Fecha finalizado", cell: x => ({ data: kea.formatDate(x.FechaCerrado) }) },
];

export interface BotonesDeps {
    onCerrar: (item: Entity) => void;
}

function botones(deps: BotonesDeps): kea.Grid2Column<Entity, undefined> {
    return kea.columnaBotones<Entity>([
        {
            tooltip: "Modificar concepto",
            style: "primary",
            iconClass: fa("close"),
            disabled: x => x.FechaCerrado != null || x.FechaCerrado != undefined,
            onClick: deps.onCerrar
        }
    ]);
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps), ...columnasFijas];
}

/**
* Listado de CargaZE
*/
class CargaZEListNoRx extends React.PureComponent<Props> {

    private onCerrar = async (x: Entity) => {
        if (await kea.yesno("¿Finaliza carga de zona extendida?", "" + x.Folio)) {
            await resources.CargaZE.FinalizarCarga(x.IdRegistro);
            await resources.ChoferZE.Nada();
            await kea.message("La carga de zona extendida ha sido finalizada");
        }
    }

    render() {
        const cols = columnas({ onCerrar: this.onCerrar });
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            <span>Cargas del chofer</span>
                        </h4>
                    </div>
                </div>
                <kea.Grid2 items={this.props.value} columnas={cols} />
            </div>
        );
    }
}
export const CargaZEList = kea.mapProps(componentToRx(CargaZEListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/resumenchoferze/list/componentes/cargas/list.tsx